import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerLocalization from "../../controller/Localization";
import ControllerPayeeProfile from "../../controller/custom/PayeeProfile";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPagePayeeProfile: React.FC = () => {
    // Variable
    const controllerPayeeProfile = new ControllerPayeeProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerPayeeProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerPayeeProfile.getSelectOption && controllerPayeeProfile.getValidationForm) {
        return (
            <div className="view_payee_profile form" data-at_id="view_payee_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerPayeeProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        html.push(
                                            <div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled"
                                                        name="id"
                                                        label={controllerLocalization.getStorageMain.id}
                                                        defaultValue={controllerPayeeProfile.getDataMain.id || ""}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value date"
                                                        data-at_id="input_latest_update"
                                                        name="latest_update"
                                                        label={controllerLocalization.getStorageMain.latest_update}
                                                        value={
                                                            controllerPayeeProfile.getDataMain.latest_update
                                                                ? HelperSrc.localeFormat(new Date(controllerPayeeProfile.getDataMain.latest_update))
                                                                : ""
                                                        }
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_latest_update_by_id"
                                                        name="latest_update_by_id"
                                                        label={controllerLocalization.getStorageMain.latest_update_by}
                                                        defaultValue={(() => {
                                                            for (const optionData of Object.values(
                                                                controllerPayeeProfile.getSelectOption.latest_update_by_id
                                                            )) {
                                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                                if (
                                                                    controllerPayeeProfile.getDataMain.latest_update_by_id === optionDataTyped.value
                                                                ) {
                                                                    return optionDataTyped.display_name;
                                                                }
                                                            }
                                                        })()}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                            </div>
                                        );

                                        return html;
                                    })()}
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerPayeeProfile.getSelectOption.client_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerPayeeProfile.getElementClientIdValue === "" && controllerPayeeProfile.getDataMain
                                                        ? controllerPayeeProfile.getDataMain.client_id
                                                        : controllerPayeeProfile.getElementClientIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(controllerPayeeProfile.getSelectOption.client_id)) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_client_id"
                                                        required={
                                                            controllerPayeeProfile.getValidationForm
                                                                ? controllerPayeeProfile.getValidationForm.client_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => {
                                                            HelperSrc.checkRegexSelect(event.target.name, event.target.value);
                                                        }}
                                                        label={
                                                            controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.client : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="client_id"
                                                        defaultValue={
                                                            controllerPayeeProfile.getElementClientIdValue === "" &&
                                                            controllerPayeeProfile.getDataMain
                                                                ? controllerPayeeProfile.getDataMain.client_id !== undefined
                                                                    ? controllerPayeeProfile.getDataMain.client_id
                                                                    : ""
                                                                : controllerPayeeProfile.getElementClientIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerPayeeProfile.setElementClientIdValue) {
                                                    controllerPayeeProfile.setElementClientIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_bank_name"
                                            name="bank_name"
                                            label={controllerLocalization.getStorageMain.bank_name}
                                            defaultValue={controllerPayeeProfile.getDataMain.bank_name || ""}
                                            required={controllerPayeeProfile.getValidationForm.bank_name.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.bank_name.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.bank_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_branch_name"
                                            name="branch_name"
                                            label={controllerLocalization.getStorageMain.branch_name}
                                            defaultValue={controllerPayeeProfile.getDataMain.branch_name || ""}
                                            required={controllerPayeeProfile.getValidationForm.branch_name.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.branch_name.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.branch_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_bank_code"
                                            name="bank_code"
                                            label={controllerLocalization.getStorageMain.bank_code}
                                            defaultValue={controllerPayeeProfile.getDataMain.bank_code || ""}
                                            required={controllerPayeeProfile.getValidationForm.bank_code.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.bank_code.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.bank_code.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_branch_code"
                                            name="branch_code"
                                            label={controllerLocalization.getStorageMain.branch_code}
                                            defaultValue={controllerPayeeProfile.getDataMain.branch_code || ""}
                                            required={controllerPayeeProfile.getValidationForm.branch_code.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.branch_code.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.branch_code.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerPayeeProfile.getSelectOption.account_type_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerPayeeProfile.getElementAccountTypeIdValue === "" && controllerPayeeProfile.getDataMain
                                                        ? controllerPayeeProfile.getDataMain.account_type_id
                                                        : controllerPayeeProfile.getElementAccountTypeIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(controllerPayeeProfile.getSelectOption.account_type_id)) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_account_type_id"
                                                        required={
                                                            controllerPayeeProfile.getValidationForm
                                                                ? controllerPayeeProfile.getValidationForm.account_type_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => {
                                                            HelperSrc.checkRegexSelect(event.target.name, event.target.value);
                                                        }}
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.account_type_id
                                                                : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="account_type_id"
                                                        defaultValue={
                                                            controllerPayeeProfile.getElementAccountTypeIdValue === "" &&
                                                            controllerPayeeProfile.getDataMain
                                                                ? controllerPayeeProfile.getDataMain.account_type_id !== undefined
                                                                    ? controllerPayeeProfile.getDataMain.account_type_id
                                                                    : ""
                                                                : controllerPayeeProfile.getElementAccountTypeIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerPayeeProfile.setElementAccountTypeIdValue) {
                                                    controllerPayeeProfile.setElementAccountTypeIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_ac_number"
                                            name="ac_number"
                                            label={controllerLocalization.getStorageMain.ac_number}
                                            defaultValue={controllerPayeeProfile.getDataMain.ac_number || ""}
                                            required={controllerPayeeProfile.getValidationForm.ac_number.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.ac_number.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.ac_number.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_account_name"
                                            name="account_name"
                                            label={controllerLocalization.getStorageMain.account_name}
                                            defaultValue={controllerPayeeProfile.getDataMain.account_name || ""}
                                            required={controllerPayeeProfile.getValidationForm.account_name.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.account_name.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.account_name.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_account_name_kanji"
                                            name="account_name_kanji"
                                            label={controllerLocalization.getStorageMain.account_name_kanji}
                                            defaultValue={controllerPayeeProfile.getDataMain.account_name_kanji || ""}
                                            required={controllerPayeeProfile.getValidationForm.account_name_kanji.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.account_name_kanji.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.account_name_kanji.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_swift"
                                            name="swift"
                                            label={controllerLocalization.getStorageMain.swift}
                                            defaultValue={controllerPayeeProfile.getDataMain.swift || ""}
                                            required={controllerPayeeProfile.getValidationForm.swift.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.swift.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.swift.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiTextField
                                            variant="outlined"
                                            className="field_value"
                                            data-at_id="input_url"
                                            name="url"
                                            label={controllerLocalization.getStorageMain.url}
                                            defaultValue={controllerPayeeProfile.getDataMain.url || ""}
                                            required={controllerPayeeProfile.getValidationForm.url.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.url.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.url.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <span className="checkbox_label">{controllerLocalization.getStorageMain.is_active}:</span>
                                        <MuiCheckbox
                                            className="field_value checkbox_style"
                                            data-at_id="input_is_active"
                                            name="is_active"
                                            defaultChecked={controllerPayeeProfile.getDataMain.is_active || false}
                                            required={controllerPayeeProfile.getValidationForm.is_active.required}
                                            onChange={(event) => {
                                                if (controllerPayeeProfile.getValidationForm) {
                                                    HelperSrc.checkRegex(
                                                        event.target,
                                                        event.target.value,
                                                        controllerPayeeProfile.getValidationForm.is_active.regex_pattern,
                                                        controllerPayeeProfile.getValidationForm.is_active.error_msg
                                                    );
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerPayeeProfile.getApiLoadingList.profileChange}
                                            onClick={(event) => {
                                                controllerPayeeProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerPayeeProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPagePayeeProfile;
